<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import ContractAddEditForm from "@/components/models/practice/forms/ContractAddEditForm.vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.contract" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__CONTRACT);
    },
  },
});
</script>

<template>
  <v-skeleton-loader>
    <contract-add-edit-form />
  </v-skeleton-loader>
</template>
